import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, dialogTitleCaptionLineHeight } from '@/core/ui';
import { BalanceLabel, InnerContainer } from './DialogTitleBalanceInfo.styled';
import { t } from '@/core/localization';
import { BalanceValue } from './BalanceValue';
const DialogTitleBalanceInfo = ({ balance }) => {
    return (_jsxs(InnerContainer, { children: [_jsx(BalanceLabel, { children: t('balance.label') }), balance === undefined ? (_jsx(Skeleton, { width: "4.5rem", height: dialogTitleCaptionLineHeight })) : (_jsx(BalanceValue, { value: balance }))] }));
};
export { DialogTitleBalanceInfo };
